import React from 'react';
import styled from 'styled-components';
import colors from '../../styles/colors';
import { textSizesPx, spaceSizesPx } from '@nauto/core';

interface PanelTitleProps {
  className?: string;
  title?: string;
  children?: any;
}

class PanelTitle extends React.Component<PanelTitleProps, any> {
  render() {
    const { className, title, children } = this.props;
    return (
      <div className={`panel-bar ${className}`}>
        {title && <div className="panel-header">{title}</div>}
        <div className="panel-body">{children}</div>
      </div>
    );
  }
}

const StyledPanelTitle = styled(PanelTitle)`
  font-size: ${textSizesPx.md};
  border: 1px solid ${colors.grey100};
  padding: ${spaceSizesPx.md};
  width: 100%;
  height: 100%;
  .panel-header {
    color: black;
    font-family: Circular-Bold;
  }
  .panel-body {
    position: relative;
    margin-top: ${spaceSizesPx.xl};
  }
`;

export default StyledPanelTitle as any;
